import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LessPennyService } from '_services/lesspenny.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'LessPennyAdmin';
  homeactive: boolean;
  advertisersActive: boolean;
  advDetailsactive: boolean;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.setActiveIndicator(val.url.split('/'));
      }
    });
  }

  ngOnInit(): void {

  }

  resetActiveIndicator() {
    this.homeactive = false;
    this.advertisersActive = false;
    this.advDetailsactive = false;
  }

  setActiveIndicator(currentUrl: any) {
    // if (
    //   currentUrl[1] === '' ||
    //   currentUrl[1] === null ||
    //   currentUrl[1] === undefined) {
    //   this.router.navigate(['../content'], { queryParams: { 'key': 'TMDocumentSplash' } });
    // } else    
    this.resetActiveIndicator();
    if (currentUrl[1] === '') {
      this.homeactive = true;
    }
    else if (currentUrl[1] === 'advertisers') {
      this.advertisersActive = true;
    }
    else if (currentUrl[1] === 'Details') {
      this.advDetailsactive = true;
    }
  }

}
